import { Button, TYPE } from 'components/Button'
import ButtonGroup from 'components/ButtonGroup'
import { ButtonGroupType } from 'components/ButtonGroup/ButtonGroup'
import Icon from 'components/Icon'
import { SRPRS } from 'Icon/srprs'
import { UI } from 'Icon/ui'
import * as React from 'react'
import { DefaultContent } from 'react-content-engine'

interface HeaderProps {
  day?: number
  monthName: string
  year: number
  disableLeftButton?: boolean
  disableRightButton?: boolean
  onClickLeft: () => void
  onClickRight: () => void
  icon?: string
}

type CalendarIcon = 'calendar' | 'calendarColored'

const CalendarHeader: React.FC<HeaderProps>  = props => {
  return (
    <header>
      <Button
        className="previous-month"
        onClick={props.onClickLeft}
        disabled={props.disableLeftButton}
      >
        <Icon icon={UI.chevronLeft} />
      </Button>
      <div>
        <span className="month-name">
          <DefaultContent contentKey={props.monthName.toLocaleLowerCase()}>
            {props.monthName}
          </DefaultContent>
        </span>
        <span className="year-name">{props.year}</span>
      </div>
      <Button
        className="next-month"
        onClick={props.onClickRight}
        disabled={props.disableRightButton}
      >
        <Icon icon={UI.chevronRight} />
      </Button>
    </header>
  )
}

const ActionListHeader: React.FC<HeaderProps> = props => {
  return (
    <header className="header-extended">
      <div className={'date-date'}>
        <Icon icon={SRPRS[props.icon as CalendarIcon]?.(props.day)} />
      </div>
      <div className={'date-month'}>
        <span className={'heading'}>
          <DefaultContent addNode contentKey="departure-date">
            Departure Date
          </DefaultContent>
        </span>
        <strong>
          <DefaultContent
            addNode
            contentKey={props.monthName.toLocaleLowerCase()}
          >
            {props.monthName}
          </DefaultContent>
          <span className={'year'}> {props.year}</span>
        </strong>
      </div>

      <ButtonGroup type={ButtonGroupType.pagination}>
        <Button
          type={TYPE.ghost}
          cutOff={'right'}
          onClick={props.onClickLeft}
          disabled={props.disableLeftButton}
        >
          <Icon icon={UI.chevronLeft} />
        </Button>

        <Button
          type={TYPE.ghost}
          cutOff={'left'}
          onClick={props.onClickRight}
          disabled={props.disableRightButton}
        >
          <Icon icon={UI.chevronRight} />
        </Button>
      </ButtonGroup>
    </header>
  )
}

export { CalendarHeader, ActionListHeader }
